import { lazy } from 'react';

import Main from 'src/layouts/Main/Layout';
import Home from "src/pages/home/Home";



const Contact = lazy(() => (import("src/pages/contact/Contact")));
// const PrivacyPolicy = lazy(() => (import("src/pages/privacy_policy/PrivacyPolicy")));
const About = lazy(() => (import("src/pages/about/About")));
const Supplements = lazy(() => (import("src/pages/products/supplements/list/Supplements")));
const SupplementDetails = lazy(() => (import("src/pages/products/supplements/details/Details")));



const routes = [
    {
        path: '/',
        element: Main,
        routes: [
            {
                path: '',
                element: Home
            },

            {
                path: 'contact',
                element: Contact
            },
            // {
            //     path: 'privacy-policy',
            //     element: PrivacyPolicy
            // },
            {
                path: 'about',
                element: About
            },
            {
                path: "supplements",
                element: Supplements
            },
            {
                path: "supplements/:slug",
                element: SupplementDetails
            }

        ]
    }
];

export default routes;
